import React, { useEffect, useState } from 'react';
import { FieldValues, UseFormSetValue } from 'react-hook-form';
import styles from './Input.module.scss';
import cx from 'classnames';
import { Icon, Text } from 'components';
import { Icons } from 'components/Icon/Icon';

type Props = {
  labelText?: string;
  inputName: string;
  errorMsg?: string;
  canContainError?: boolean;
  canBeHidden?: boolean;
  characterCounter?: boolean;
  currentValue?: string | number;
  showContacts?: boolean;
  register(fieldName: string, registerOptions?: { [key: string]: any }): any;
  registerOptions?: { [key: string]: any };
  iconName?: Icons;
  setValue?: UseFormSetValue<any>;
  canBeCleared?: boolean;
} & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

export const Input = ({
  errorMsg,
  labelText,
  inputName,
  canContainError = true,
  register,
  registerOptions,
  canBeHidden,
  characterCounter = false,
  currentValue,
  showContacts = false,
  iconName,
  setValue,
  canBeCleared,
  className,
  ...props
}: Props) => {
  const [isTextHidden, setIsTextHidden] = useState(true);
  const currentValueLength =
    currentValue === undefined
      ? 0
      : typeof currentValue === 'number'
        ? String(currentValue).length
        : currentValue.length;

  const clearValue = () => setValue && setValue(inputName, '');

  useEffect(() => {
    if (props?.maxLength && currentValue && String(currentValue).length > props?.maxLength) {
      const newValue = String(currentValue).slice(0, props.maxLength);
      setValue && setValue(inputName, newValue);
    }
  }, [currentValue]);

  return (
    <div className={cx(styles.inputItem, className, { [styles.isDisabled]: props.disabled })}>
      {labelText && (
        <label htmlFor={inputName}>
          <Text type="caption">{labelText}</Text>
        </label>
      )}
      <div
        className={cx(styles.inputContainer, {
          [styles.hideContacts]: !showContacts,
          [styles.withIcon]: canBeCleared || canBeHidden,
          [styles.withLeftIcon]: canBeCleared,
        })}>
        {iconName && <Icon name={iconName} className={styles.leftIcon} />}
        <input
          type={canBeHidden && isTextHidden ? 'password' : 'text'}
          name={inputName}
          {...register(inputName, registerOptions)}
          {...props}
        />
        {!!currentValueLength && canBeCleared && (
          <Icon name="Close" className={styles.clearIcon} onClick={clearValue} />
        )}
        {canBeHidden && (
          <Icon
            name={isTextHidden ? 'ClosedEye' : 'OpenedEye'}
            onClick={() => setIsTextHidden(!isTextHidden)}
            className={styles.icon}
          />
        )}
      </div>
      {canContainError && !characterCounter && (
        <div className={styles.inputItemInfo}>
          <Text type="caption" className={styles.error}>
            {errorMsg}
          </Text>
        </div>
      )}
      {characterCounter && props.maxLength && (
        <div className={styles.inputItemInfo}>
          {canContainError && (
            <Text type="caption" className={styles.error}>
              {errorMsg}
            </Text>
          )}
          <Text type="caption" className={styles.counter}>
            {currentValueLength}/{props.maxLength} characters
          </Text>
        </div>
      )}
    </div>
  );
};
